module.exports = __webpack_public_path__ + "assistmh-logo-e47943bf1157ac2355b58b6373c8fcb8.png";